module.exports = __webpack_public_path__ + "img/H-B-1-load-connect-shadow.975ad675.png";